// FILE: src/components/layout/Sidebar.jsx
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});

  const toggleSubmenu = (menuKey) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  const menuItems = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      icon: '📊',
      path: '/',
      submenu: [
        { label: 'E-Commerce Analytics', path: '/ecommerce' },
        { label: 'Marketing Overview', path: '/marketing' },
        { label: 'SaaS Dashboard', path: '/saas' }
      ]
    },
    {
      key: 'crm',
      label: 'CRM',
      icon: '👥',
      path: '/crm',
      submenu: [
        { label: 'Customer List', path: '/crm/customers' },
        { label: 'Leads', path: '/crm/leads' },
        { label: 'Contacts', path: '/crm/contacts' }
      ]
    },
    {
      key: 'products',
      label: 'Products',
      icon: '📦',
      path: '/products',
      submenu: [
        { label: 'Product List', path: '/products/list' },
        { label: 'Categories', path: '/products/categories' },
        { label: 'Inventory', path: '/products/inventory' }
      ]
    },
    {
      key: 'orders',
      label: 'Orders',
      icon: '🛒',
      path: '/orders'
    },
    {
      key: 'analytics',
      label: 'Analytics',
      icon: '📈',
      path: '/analytics'
    },
    {
      key: 'settings',
      label: 'Settings',
      icon: '⚙️',
      path: '/settings'
    },
    {
      key: 'auth',
      label: 'Authentication',
      icon: '🔐',
      path: '/auth',
      submenu: [
        { label: 'Login', path: '/login' },
        { label: 'Registration', path: '/register' }
      ]
    }
  ];

  const isActiveMenu = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <>
      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-50 w-64 bg-white dark:bg-gray-800 shadow-lg transform transition-transform duration-300 ease-in-out
        lg:translate-x-0 lg:static lg:inset-0
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        {/* Logo */}
        <div className="flex items-center justify-center h-16 px-4 bg-primary-600 text-white">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
              <span className="text-primary-600 font-bold text-lg">C</span>
            </div>
            <span className="text-xl font-bold">CodingAdmin</span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="mt-8 px-4">
          <div className="space-y-2">
            {menuItems.map((item) => (
              <div key={item.key}>
                {/* Main Menu Item */}
                <button
                  onClick={() => {
                    if (item.submenu) {
                      toggleSubmenu(item.key);
                    } else {
                      navigate(item.path);
                      setIsOpen(false);
                    }
                  }}
                  className={`
                    w-full flex items-center justify-between px-4 py-3 text-sm font-medium rounded-lg transition-colors
                    ${isActiveMenu(item.path) 
                      ? 'bg-primary-100 text-primary-700 dark:bg-primary-900 dark:text-primary-300' 
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white'
                    }
                  `}
                >
                  <div className="flex items-center">
                    <span className="mr-3">{item.icon}</span>
                    {item.label}
                  </div>
                  {item.submenu && (
                    <svg 
                      className={`w-4 h-4 transform transition-transform duration-200 ${expandedMenus[item.key] ? 'rotate-180' : ''}`}
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                </button>

                {/* Submenu */}
                {item.submenu && expandedMenus[item.key] && (
                  <div className="ml-4 mt-2 space-y-1">
                    {item.submenu.map((subItem) => (
                      <button
                        key={subItem.path}
                        onClick={() => {
                          navigate(subItem.path);
                          setIsOpen(false);
                        }}
                        className={`
                          w-full text-left px-4 py-2 text-sm rounded-lg transition-colors
                          ${location.pathname === subItem.path
                            ? 'bg-primary-50 text-primary-600 dark:bg-primary-900 dark:text-primary-400'
                            : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-300'
                          }
                        `}
                      >
                        {subItem.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;